<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';

	import Section from '$lib/components/fragments/Section.svelte';
	import Callout from '$lib/components/fragments/Callout.svelte';
	import Picture from '$lib/components/media/Picture.svelte';
	import Headline from '$lib/components/fragments/Headline.svelte';

	const copy = $derived(getCopy().moving_forward);
</script>

<Section id="conclusion" class="bg-cream text-black">
	<div class="content-well-lg -mb-10 md:-mb-30">
		<Picture src="future.webp" alt={copy.alt} class="h-full w-full object-contain" />
	</div>
	<div class="content-well-sm">
		<Headline overline={copy.overline} title={copy.title} />
		<p class="body-1">{@html md(copy.copy_before)}</p>
	</div>

	<Callout class="px-8 py-12">
		<p class="heading-4 text-blue-dark mb-10">{@html md(copy.quote.line)}</p>
		<p class="subtitle-2 text-blue-light font-bold">{@html md(copy.quote.author)}</p>
	</Callout>

	<div class="content-well-sm">
		<p class="body-1">{@html md(copy.copy_after)}</p>
	</div>
</Section>
